import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivyAuthProvider } from '@butternetwork/shared-auth';
import { ThemeProvider, ThemedToaster } from '@butternetwork/shared-ui';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element in index.html');

// Match React Router basename to the same VITE_SHELL_HOME_URL that vite uses
// for `base`. Strip trailing slash because Router expects "/hub" not "/hub/".
const shellHome = (import.meta as any).env?.VITE_SHELL_HOME_URL as string | undefined;
const basename = shellHome && shellHome !== '/'
  ? shellHome.replace(/\/$/, '')
  : undefined;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <PrivyAuthProvider>
          <BrowserRouter basename={basename}>
            <App />
          </BrowserRouter>
        </PrivyAuthProvider>
        <ThemedToaster />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
